import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import { Select } from 'components/FormInputs';

const ListFilters = ({ changeFilter, filter, tags }) => {
  return (
    <>
      <Box p={1} textAlign="right">
        <Select
          multiple
          onChange={changeFilter}
          onBlur={null}
          value={filter}
          fullWidth={false}
          name="filter"
          errors={{}}
          label={<FormattedMessage id="Filter by" defaultMessage="Filter by" />}
          style={{ minWidth: 200 }}
          renderValue={(selected) =>
            selected.map((id) => tags.find((t) => t.id === id).tag).join(', ')
          }
          options={tags
            .filter(({ id, used }) => used || id <= 3)
            .map(({ id, tag }) => ({
              label: (
                <>
                  <Checkbox color="primary" checked={filter.includes(id)} />
                  {tag}
                </>
              ),
              value: id,
            }))}
        />
      </Box>
      <Divider />
      <Divider />
    </>
  );
};

ListFilters.propTypes = {
  changeFilter: PropTypes.func.isRequired,
  filter: PropTypes.arrayOf(PropTypes.string),
  tags: PropTypes.arrayOf(PropTypes.shape({})),
};

export default ListFilters;
